module.exports = __webpack_public_path__ + "assets/img/black-logo.76ddd3cb.svg";